import { render, staticRenderFns } from "./editar-pessoa.vue?vue&type=template&id=d4577faa&"
import script from "./editar-pessoa.vue?vue&type=script&lang=ts&"
export * from "./editar-pessoa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4577faa')) {
      api.createRecord('d4577faa', component.options)
    } else {
      api.reload('d4577faa', component.options)
    }
    module.hot.accept("./editar-pessoa.vue?vue&type=template&id=d4577faa&", function () {
      api.rerender('d4577faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pessoa/editar-pessoa.vue"
export default component.exports